import React from "react";
import { ProgramData } from "@interfaces/Interfaces";
import * as ProgramUtils from "@utils/programUtils";

type Props = {
  skillID: string;
  program: ProgramData;
};

const EvidenceSkillDisplay: React.FC<Props> = (props) => {
  if (!props.skillID) return null;

  const skill = ProgramUtils.getAllSkillsFromRoles(props.program).find((item) => item.ID === props.skillID);

  if (!skill) return null;

  return (
    <>
      <div className="readEvidenceBlock">
        <div className="readEvidenceHeader">Skill</div>
        <div className="readEvidenceText">{skill.Name}</div>
        <div className="h-[1px] w-full bg-grey-30 mt-4" />
      </div>
    </>
  );
};

export default EvidenceSkillDisplay;
